/*
const Papa = require("papaparse");

const parseFile = (csvLink) =>
  new Promise((resolve) => {
    Papa.parse(csvLink, {
      download: true,
      header: true,
      complete: (results) => {
        resolve(results.data);
      },
    });
  });

export async function fetchParsedData(csvLink) {
  const parsedData = await parseFile(csvLink);
  return parsedData;
}
*/

// util/dataMigrationPapaparse.js
// ESM 환경이면 import로, CJS면 require 그대로 쓰셔도 됩니다.
import Papa from "papaparse";

/** pub/gviz 링크여도 export CSV로 강제 변환 */
function toExportCsvUrl(inputUrl) {
  try {
    // d/e/ 형식의 게시된 URL은 이미 올바른 형식이므로 그대로 반환
    if (/\/spreadsheets\/d\/e\//.test(inputUrl)) {
      return inputUrl;
    }

    const idMatch = inputUrl.match(/\/spreadsheets\/d\/([^/]+)/);
    const gidMatch = inputUrl.match(/[?&]gid=(\d+)/);
    const sheetId = idMatch?.[1];
    const gid = gidMatch?.[1] ?? "0";
    if (!sheetId) return inputUrl; // 못 뽑으면 원문 사용(최후 fallback)
    return `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv&gid=${gid}`;
  } catch {
    return inputUrl;
  }
}

/** HTTP 상태 & HTML 응답 방어 */
async function fetchCsvText(csvLink) {
  const url = toExportCsvUrl(csvLink);
  const res = await fetch(url, { method: "GET" });

  if (!res.ok) {
    throw new Error(`CSV HTTP ${res.status} at ${url}`);
  }

  const text = await res.text();

  // 구글이 로그인/퍼미션 문제로 HTML을 줄 때 방어
  const looksHtml = /^\s*</.test(text) && /<html|<!doctype/i.test(text);
  if (looksHtml) {
    throw new Error(
      "CSV 대신 HTML이 내려왔습니다. 시트 공개 범위(링크 공개/보기)나 권한을 확인하세요."
    );
  }
  if (!text || text.trim().length === 0) {
    throw new Error("CSV 응답이 비어 있습니다.");
  }
  return text;
}

export async function fetchParsedData(csvLink) {
  const csvText = await fetchCsvText(csvLink);
  return new Promise((resolve, reject) => {
    Papa.parse(csvText, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        // 데이터가 비정상적으로 비었는지 한 번 더 체크
        if (!results?.data || results.data.length === 0) {
          reject(new Error("CSV 파싱 결과가 비어 있습니다."));
        } else {
          resolve(results.data);
        }
      },
      error: (err) => reject(err),
    });
  });
}
